import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { InvoiceButtons } from "../common/InvoiceButtons";
import InvoiceSixHeader from "./InvoiceSixHeader";
import InvoiceSixTable from "./InvoiceSixTable";
import UserDetails from "./UserDetails";
import { ECommerce, Invoice } from "../../../../../constants";
import Breadcrumbs from "../../../../../coreComponents/breadcrumbs";

// This component displays the invoice 6, including invoice header, user details, table, and buttons.
const InvoiceSixContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={Invoice} parent={ECommerce} />
      <Container>
        <Row>
          <Col sm="12">
            <div>
              <Card>
                <CardBody>
                  <div className="invoice">
                    <div>
                      <InvoiceSixHeader />
                      <hr />
                      <UserDetails />
                      <InvoiceSixTable />
                    </div>
                  </div>
                </CardBody>
              </Card>
            </div>
          </Col>
        </Row>
      </Container>
      <InvoiceButtons />
    </>
  );
};

export default InvoiceSixContainer;
